import Vue from 'vue';
import { getTimestampUnit } from '@/hotelcem/utils/constants'

    import dayjs from 'dayjs'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    

export const getAxisDataList = dateRange => {
  const timestampUnit = getTimestampUnit(dateRange)
  let start = dayjs(dateRange[0]).set('hour', 0).set('minute', 0).set('second', 0)
  let end = dayjs(dateRange[1]).set('hour', 0).set('minute', 0).set('second', 0)
  const axisList = []
  while (start.isBefore(end) || start.isSame(end)) {
    if (timestampUnit === 'Day') {
      axisList.push(start.format('YYYY-MM-DD HH:mm:ss'))
      start = start.add(1, 'day')
    } else if (timestampUnit === 'Week') {
      start = start.set('day', 1)
      axisList.push(start.format('YYYY-MM-DD HH:mm:ss'))
      start = start.add(1, 'week')
    } else {
      start = start.set('date', 1)
      end = end.set('date', 1)
      axisList.push(start.format('YYYY-MM-01 HH:mm:ss'))
      start = start.add(1, 'month')
    }
  }
  return axisList
}

export const getDataOverviewAxisDataList = (dateRange, timestampUnit) => {
  let start = dayjs(dateRange[0]).set('hour', 0).set('minute', 0).set('second', 0)
  let end = dayjs(dateRange[1]).set('hour', 0).set('minute', 0).set('second', 0)
  const axisList = []
  while (start.isBefore(end) || start.isSame(end)) {
    if (timestampUnit === 'Day') {
      start = start.set('day', 1)
      axisList.push(start.format('YYYY-MM-01 HH:mm:ss'))
      start = start.add(1, 'day')
    } else if (timestampUnit === 'Week') {
      start = start.set('date', 1)
      end = end.set('date', 1)
      axisList.push(start.format('YYYY-MM-01 HH:mm:ss'))
      start = start.add(1, 'week')
    } else {
      start = start.set('date', 1)
      end = end.set('date', 1)
      axisList.push(start.format('YYYY-MM-01 HH:mm:ss'))
      start = start.add(1, 'month')
    }
  }
  return axisList
}

export const fmtAxisDataList = (dateRange, axisDataList) => {
  const timestampUnit = getTimestampUnit(dateRange)
  return axisDataList.map(item => {
    let date = dayjs(item, 'YYYY-MM-DD')
    if (timestampUnit === 'Day') {
      date = date.format('MM/DD')
    } else if (timestampUnit === 'Week') {
      date = date.format('MM/DD')
    } else {
      date = date.format('YYYY/MM')
    }
    return date
  })
}

export const getWeekWithDayStr = (dayStr, dateRange) => {
  const timestampUnit = getTimestampUnit(dateRange)
  if (timestampUnit !== 'Week') {
    return dayStr
  }
  let date = dayjs().year() + '/' + dayStr.replace($t('9954ce'), '/').replace($t('ac2c5e'), '')
  return dayStr + '-' + dayjs(date).add(6, 'day').format('MM/DD')
}

export const getStartDateList = (dateRange = [], timestampUnit = 'day') => {
  timestampUnit = timestampUnit.toLowerCase()
  let start = dayjs(dateRange[0])
  let end = dayjs(dateRange[1])
  let dateList = []
  while (start.isBefore(end) || start.isSame(end)) {
    if (timestampUnit === 'day') {
      dateList.push(start.format('YYYY-MM-DD'))
      start = start.add(1, 'day')
    } else if (timestampUnit === 'week') {
      start = start.startOf('week').add(1, 'day')
      dateList.push(start.format('YYYY-MM-DD'))
      start = start.add(7, 'day')
    } else if (timestampUnit === 'month') {
      start = start.startOf('month')
      dateList.push(start.format('YYYY-MM-DD'))
      start = start.add(1, 'month')
    }
  }
  return dateList
}
